
import AppCompanyEditUserModal from "@/components/company/CompanyEditUserModal.vue";
import { MODULE } from "@/config/modules";
import { Company } from "@/models/company";
import { ExtraUsersMetaData } from "@/models/module-extra-users-meta-data";
import { User } from "@/models/user";
import { CompanyUserService } from "@/services/company-user-service";
import Vue from "vue";
import AppCompanyEditWrapper from "./CompanyEditWrapper.vue";
import AppLoginAsUserButton from "@/components/LoginAsUserButton.vue";
import AppCompanyEditUserDevices from "./CompanyEditUserDevices.vue";

export default Vue.extend({
	data() {
		return {
			editModal: false,
			columns: [
				{
					name: "Id",
					property: "id",
					width: "50px"
				},
				{
					name: "Username",
					property: "username",
					width: "200px"
				},
				{
					name: "Email",
					property: "email",
					width: "200px"
				},
				{
					name: "",
					property: "isOwner",
					width: "200px",
					print(value:boolean):string {
						if (value) {
							return "Owner";
						}
						return "";
					}
				},
			],
			orderColumn: "id",
			orderDirection: false,
			selected: [] as User[],
			toEditUser: new User(),
			manageUserDevicesModal: false
		};
	},
	props: {
		value: {
			type: Object as () => Company,
			required: true
		}
	},
	computed: {
		orderedUsers():User[] {
			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			let result = this.users.sort((a:any, b:any) => {
				if (typeof(a[this.orderColumn]) == "string") {
					if (this.orderDirection) {
						return (a[this.orderColumn] as string).localeCompare(b[this.orderColumn]);
					}
					return (b[this.orderColumn] as string).localeCompare(a[this.orderColumn]);
				}
				if (this.orderDirection) {
					return (a[this.orderColumn] as number) - (b[this.orderColumn] as number);
				}
				return(b[this.orderColumn] as number) - (a[this.orderColumn] as number);
			});
			return result;
		},
		users():User[] {
			return this.value.users;
		},
		addUrl():string {
			return `/companies/${this.value.id}/add-users`;
		},
		addDisabled():boolean {
			for(let m of this.value.modules){
				if (m.id == MODULE.EXTRA_USERS){
					let extraCount = ExtraUsersMetaData.create(m.metaData).getExtraUsers();
					if (extraCount+1 > this.value.users.length){
						return false;
					}
				}
			}
			return true;
		},
	},
	methods: {
		async removeUsers() {
			if (this.selected.length == 0) return;
			let result = await this.$wf.confirm("Are you sure you want to delete these users?", "YES", "NO", "WARNING");
			if (!result) return;
			for (let user of this.selected) {
				CompanyUserService.deleteUser(this.value.id, user).then(() => {
					this.users.splice(this.users.findIndex((u:User) => u.id == user.id), 1);
				});
			}
			this.selected = [];
		},
		onOrder(event:any) {
			this.orderColumn = event.order;
			this.orderDirection = event.ascending;
		},
		editUser(user?:User) {
			let u = user;
			if (!u){
				u = this.selected[0];
			}
			if (!u) return;
			this.editModal = true;
			this.toEditUser = this.selected[0];
		},
		addUserClicked() {
			this.editModal = true;
			this.toEditUser = new User();
			this.toEditUser.companyId = this.value.id;
		},
		onUserSave(user:User) {
			let i = this.value.users.findIndex(u => u.id == user.id);
			if (i == -1) {
				this.value.users.push(user);
			} else {
				this.value.users[i] = user;
			}
		},
		createTicket(){
			if (!this.selected[0]) return;
			this.$router.push(`/ticket/new?userId=${this.selected[0].id}&companyId=${this.selected[0].companyId}`);
		},
		manageUserDevices(){
			this.manageUserDevicesModal = true;
		}
	},
	components: {
		AppCompanyEditUserModal,
		AppCompanyEditWrapper,
		AppLoginAsUserButton,
		AppCompanyEditUserDevices
	}
});
